import { getRequest, postRequest } from "../../../services/RestServices";
import * as urls from "../../api/scheduler/url";
export const getMaterialInstallersList = async (payload) => {
  try {
    return await postRequest(urls.GET_MATERIAL_INSTALLERS, payload);
  } catch (err) {
    return err;
  }
};
